export default class Weapon {
  name;
  cost;
  type;
  stats = {};
  rules = [];
  description;
  addon = false;

  constructor(xmlData, cost) {
    this.cost = parseInt(cost[0].attributes.value);
    this.buildWeapon(xmlData, cost);
  }

  buildWeapon(data) {
    this.name = data.attributes.name;

    if (this.cost > 0) {
      this.addon = true;
    }
    this.setType(data);
    this.buildStats(data.getElementsByTagName('characteristic'));
  }

  setType(data) {
    switch (data.attributes.typeName) {
      case 'Equipment':
        this.type = 'equipment';
        this.description = data.getElementsByTagName('characteristic')[0].value
        break;
      case 'Unique Actions':
        this.type = 'unique_action';
        this.description = data.getElementsByTagName('characteristic')[0].value
        break;
      case 'Abilities':
        this.type = 'ability';
        this.description = data.getElementsByTagName('characteristic')[0].value
        break;
      default:
        this.type = 'weapon';
        break;
    }

  }

  buildStats(data) {
    data.map((stat) => {
      this.stats[stat.attributes.name] = stat.value;
    });
  }
}